import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AxiosError } from "axios";
import {
  apiOnboardingKeyName,
  apiOnboardingKeyValue,
  endpoints,
  getOnboardingFetcher,
  getResumeFetcher,
} from "./ApiConfig";
import {
  getRecaptchaToken,
  transformAxiosToFetchBaseQueryErrorWithLocationRedirect,
} from "../utils";
import { GenerateOtpPayload, GenerateOtpResponse } from "./types";

export const generateOtpApi = createApi({
  reducerPath: "generateOtpApi",
  baseQuery: fetchBaseQuery({
    baseUrl: endpoints.generateOtp,
    prepareHeaders: headers => {
      if (apiOnboardingKeyName && apiOnboardingKeyValue) {
        headers.set(apiOnboardingKeyName, apiOnboardingKeyValue);
      }
      return headers;
    },
  }),
  tagTypes: ["GenerateOtp"],
  endpoints: builder => ({
    generateSendOtp: builder.mutation<GenerateOtpResponse, GenerateOtpPayload>({
      async queryFn({ otpType, processId, isResume }) {

        // GENERATE OTP FOR RESUME FLOW
        if (isResume) {
          try {
            const res = await getResumeFetcher().post("/otp/send", processId);
            return { data: res?.data };
          } catch (e) {
            const error =
              transformAxiosToFetchBaseQueryErrorWithLocationRedirect(
                e as AxiosError,
              );
            return { error };
          }
        }
        
        // GENERATE OTP FOR ONBOARDING FLOW
        try {
          const gRecaptchaResponse = await getRecaptchaToken();
          const result = await getOnboardingFetcher(
            {
              gRecaptchaResponse,
            },
            undefined,
          ).post(
            `/generateSendOtp?otpType=${otpType}`,
            { processId },
            { withCredentials: true },
          );
          return { data: result.data as GenerateOtpResponse };
        } catch (e) {
          const error = transformAxiosToFetchBaseQueryErrorWithLocationRedirect(
            e as AxiosError,
          );
          return { error };
        }
      },
    }),
  }),
});

export const { useGenerateSendOtpMutation } = generateOtpApi;
